import React, { useState, useEffect } from 'react'
import { useStateValue } from './StateProvider'
import { Link, useHistory } from 'react-router-dom'
import { db, auth } from './firebase'
import { Modal, Button } from 'react-bootstrap';
function Profile() {
  const history = useHistory();
  const [{ user }] = useStateValue()
  const [details,setDetails]=useState({})
  const [fname,setFName]=useState('')
  const [lname,setLName]=useState('')
  const [contact,setContact]=useState('')
  const [address, setAddress] = useState('')
  const [showModal, setShowModal] = useState(false);
  const [showModal2, setShowModal2] = useState(false);

  useEffect(() => {
    if (user)
      db.collection('users')
        .doc(user.email)
        .get().then((doc) => {
          if (doc.exists) {
            let data=doc.data()
            setDetails(data)
            setFName(data.fname)
            setLName(data.lname)
            setAddress(data.address)
            setContact(data.contact)
          }
        }).catch((err) => {
          console.log('err is ', err)
          alert(err)
        })
  }, [user])
  const saveadd = (e) => {
    e.preventDefault()
    db.collection('users')
      .doc(user?.email)
      .set({
        fname:fname,
        lname:lname,
        address:address,
        contact:contact
      })
      db.collection('users')
        .doc(user?.email)
        .get()
        .then(doc=>{
          setDetails({
            fname:doc.data().fname,
            lname:doc.data().lname,
            address:doc.data().address,
            contact:doc.data().contact
          })
        })
    setShowModal(false)
  }
  const deleteAccount = () => {
    setShowModal2(true)
  }
  const confirmDelete=()=>{
    const user = auth.currentUser;
    user.delete().then(() => {
      db.collection('address')
        .doc(user.email)
        .delete().then(() => {
          alert('deleted')
        }).catch((err) => {
          alert(err)
        })
      history.push('/')
    }).catch((error) => {
      alert('Log out & Login again to delete this account.                                            ' + error)
    });
  }
  return (
    <div className="profile">
      <Modal
        show={showModal2}
        onHide={() => {
          setShowModal2(false);
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>Are you sure?</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          By Confirming will delete your account permanently, and this can't be undone.
          </Modal.Body>
        <Modal.Footer>
          <Button className='btn btn-success'
          onClick={confirmDelete}
          >
            Confirm
          </Button>
          <Button className='btn btn-danger'
          onClick={()=>{
            setShowModal2(0)
          }}
          >
            No
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal
        show={showModal}
        onHide={() => {
          setShowModal(false);
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>Update Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className='mb-3'>
            First name : <input type='text' className='mb-3' value={fname} onChange={(e)=>setFName(e.target.value)}/> <br/>
            Last name : <input type='text' value={lname} onChange={(e)=>setLName(e.target.value)}/>
          </div>
          <div className='d-flex'>
          Address :<textarea
            style={{display:'flex',flex:1}}
            type="text"
            className='ml-2'
            value={address}
            onChange={(e) => {
              setAddress(e.target.value)
            }}
          />
          </div>
          <div className='d-flex mt-3'>
          Contact :<input
            style={{ width: "130px" }}
            type="number"
            className='ml-2'
            value={contact}
            onChange={(e) => {
              setContact(e.target.value)
            }}
          />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={saveadd}>Save</Button>
          <Button
            onClick={() => {
              setShowModal(false);
            }}
          >
            Close
            </Button>
        </Modal.Footer>
      </Modal>
      <h1 className="text-center">My Account</h1>
      <div className="container">
        <h5>Name : {details.fname} {details.lname}</h5>
        <h5>Email : {user ? user.email : ""}</h5>
        <h5>Contact No. : {details.contact}</h5>
        <h5>Address : {details.address}</h5>
        <br />
        <pre>
          <Button
            onClick={() => {
              setShowModal(true);
            }}
          >
            Update details?
          </Button> <Button className='btn btn-danger'
            onClick={deleteAccount}
          >
            Delete account?
          </Button>

        </pre>
      </div>

      <Link to="/" className='ml-1'>Back to home</Link>
    </div>
  );
}

export default Profile
